import React from "react";
import { colors } from "../../../global";

export const CalculatorIcon = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 384 512">
    <path d="M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM64 416c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32zm0-80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32zm80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32zm0-80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32zm80 80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32zm0-80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32zM320 64H64v64h256V64z" />
  </svg>
);
export const TruckIcon = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 640 512">
    <path d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z" />
  </svg>
);
export const DollarIcon = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 320 512">
    <path d="M160 0C71.6 0 0 71.6 0 160v192c0 88.4 71.6 160 160 160s160-71.6 160-160V160C320 71.6 248.4 0 160 0zM184 320h-48v-16c-35.3 0-64-28.7-64-64 0-8.8 7.2-16 16-16s16 7.2 16 16c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32c-35.3 0-64-28.7-64-64s28.7-64 64-64v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16c35.3 0 64 28.7 64 64 0 8.8-7.2 16-16 16s-16-7.2-16-16z" />
  </svg>
);
export const ChartLineIcon = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 512 512">
    <path d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 220.7l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" />
  </svg>
);
export const AnalyticsIcon = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 448 512">
    <path d="M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z" />
  </svg>
);

// formatting helpers
export const fmtCurrency = (n) =>
  typeof n === "number" && !Number.isNaN(n)
    ? n.toLocaleString(undefined, {
        style: "currency",
        currency: "AUD",
        maximumFractionDigits: 2,
      })
    : "—";

export const fmtNumber = (n, digits = 0) =>
  typeof n === "number" && !Number.isNaN(n)
    ? n.toLocaleString(undefined, { maximumFractionDigits: digits })
    : "—";

export const fmtPercent = (n, digits = 1) =>
  typeof n === "number" && !Number.isNaN(n) ? `${n.toFixed(digits)}%` : "—";

// outcome calculator
export function outcomeMeta(initial, optimized) {
  if (typeof initial !== "number" || typeof optimized !== "number") {
    return {
      pct: null,
      absSavings: null,
      state: "unknown",
      label: "N/A",
      badge: null,
      badgeBg: "",
      badgeColor: "",
      accent: colors.info,
      description: "—",
    };
  }
  const savings = initial - optimized;
  const pct = initial !== 0 ? (savings / initial) * 100 : null;
  if (pct == null) {
    return {
      pct,
      absSavings: savings,
      state: "unknown",
      label: "N/A",
      badge: null,
      badgeBg: "",
      badgeColor: "",
      accent: colors.info,
      description: "—",
    };
  }
  const isZero = Math.abs(pct) < 0.0001;
  if (pct > 0 && !isZero) {
    return {
      pct,
      absSavings: savings,
      state: "improved",
      label: "Optimized",
      badge: "Cost Reduced",
      badgeBg: `${colors.success}15`,
      badgeColor: colors.success,
      accent: colors.success,
      description: `Costs decreased by ${pct.toFixed(2)}%`,
    };
  }
  if (isZero) {
    return {
      pct: 0,
      absSavings: 0,
      state: "flat",
      label: "No Change",
      badge: "Stable",
      badgeBg: `${colors.info}15`,
      badgeColor: colors.info,
      accent: colors.info,
      description: "No measurable change in costs",
    };
  }
  return {
    pct,
    absSavings: savings,
    state: "worse",
    label: "Cost Increased",
    badge: "Attention",
    badgeBg: `${colors.error}15`,
    badgeColor: colors.error,
    accent: colors.error,
    description: `Costs increased by ${Math.abs(pct).toFixed(2)}%`,
  };
}
